<template>
    <div id="app">
        <div class="loading" v-if="flag.loadingFlag">
            <div class="loading_icon">
                <Icon type="load-d" class="loadingIcon"></Icon>
            </div>
        </div>
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App',
        data() {
            return {
                flag: this.$api
            }
        }
    }
</script>
<style>

.loading {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1000;
    background: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}
.loadingIcon{
    color:#6236FF
}
.loading_icon {
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    color: #6236FF;
    font-size: 30px;
    transform: rotate(360deg);
    transform-origin: 50% 50%;
    animation: rotate 1.5s infinite linear;
}
@keyframes rotate {
    0% {
        transform: rotate(0deg)
    }
    100% {
        transform: rotate(360deg)
    }
}
</style>
<style>
    
    #app {
          background: #F7F7F7;
    min-height: 100%;
    /* padding-bottom: 20px; */
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        min-width: 1200px;
        /* text-align: center; */
    }
    /************************************************去除默认样式***********************************************/
    * {
        margin: 0px;
        padding: 0px;
        list-style: none;
        outline: none;
        box-sizing: border-box;
        color: #333;
    }
    img {
        width: 100%;
        height: 100%;
        border: 0;
        display: block;
    }
    a {
        text-decoration: none;
        color: #999;
        cursor: pointer;
    }
    /*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
     ::-webkit-scrollbar {
        width: 4px;
        height: 8px;
        background-color: #f5f5f5;
    }
    /*定义滚动条的轨道，内阴影及圆角*/
     ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 20px;
        background-color: #f5f5f5;
    }
    /*定义滑块，内阴影及圆角*/
     ::-webkit-scrollbar-thumb {
        border-radius: 2px;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: #999;
    }
    body,
    html {
        height: 100%;
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue